module.exports = __webpack_public_path__ + "img/logo2.90d59387.png";